import { Component, Input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import {
  ExperienceEditorComponent,
  ExperienceEditorLiveDirective,
  ExperienceEditorPreviewDirective,
} from '@core/experience-editor-components';

import { ToolTip } from './tooltip.model';

@Component({
  selector: 'wl-tooltip',
  templateUrl: './tooltip.component.html',
  standalone: true,
  imports: [
    FaIconComponent,
    NgbPopover,
    NgClass,
    ExperienceEditorComponent,
    ExperienceEditorLiveDirective,
    ExperienceEditorPreviewDirective,
  ],
})
export class ToolTipComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() tooltip?: ToolTip;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() color: 'primary' | 'secondary' | 'dark' | 'white' = 'primary';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() style: 'light' | 'solid' = 'light';

  isOpen = false;

  get tooltipColorCssClass(): string {
    return `text-${this.color}`;
  }
}
